"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));

var _bindAll2 = _interopRequireDefault(require("lodash/bindAll"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _numeral = _interopRequireDefault(require("numeral"));

var _baseStepper = _interopRequireWildcard(require("./base-stepper"));

/**
 * This specialized stepper only supports positive numbers
 *
 * It can be unrestricted on either end or just one. This can be controlled by specifying
 *  min and max as -1 (infinite) or provided.
 *
 * By default the steppers are infinite on both edges with a step size of 1.
 *
 * @class
 */
var NumStepper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(NumStepper, _React$Component);

  var _super = (0, _createSuper2.default)(NumStepper);

  function NumStepper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NumStepper);
    _this = _super.call(this, props); // While this is an anti-pattern, I'm not sure if there's a better way to handle this.

    var formatter = _this.props.stepSize < 1 && !_this.props.formatter ? '0.00' : _this.props.formatter;
    _this.state = {
      formatter: formatter,
      editing: false,
      value: _this.props.value
    };
    (0, _bindAll2.default)((0, _assertThisInitialized2.default)(_this), ['constrainValue', 'getFormattedValue', 'isHandleDisabled', 'handleTextInputFocus', 'handleTextInputChange', 'handleTextInputBlur', 'handleKeyPress', 'handleValueChange', 'handleStep']);
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  (0, _createClass2.default)(NumStepper, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // In case we receive new props - map it back to the state.
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "getFormattedValue",
    value: function getFormattedValue(value) {
      if (this.props.formatter && typeof this.props.formatter === 'function') {
        return this.props.formatter(value);
      }

      return (0, _numeral.default)(value).format(this.state.formatter);
    }
  }, {
    key: "constrainValue",
    value: function constrainValue(num, manualEdit) {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max;
      var value = num;
      value = (0, _numeral.default)(num).value();

      if (min !== -1) {
        value = Math.max(value, this.props.min);
      }

      if (max !== -1) {
        value = Math.min(value, this.props.max);
      } // Snapping behavior


      if (!manualEdit && this.props.editable && this.props.snapValues) {
        value = Math.round(value / this.props.stepSize) * this.props.stepSize;
      }

      return value;
    }
  }, {
    key: "isHandleDisabled",
    value: function isHandleDisabled(direction) {
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      var value = this.state.value;

      if (direction === _baseStepper.ENUM_LEFT && min !== -1) {
        return value === min;
      }

      if (direction === _baseStepper.ENUM_RIGHT && max !== -1) {
        return value === max;
      } // Let it be enabled if these are infinite steppers.


      return false;
    }
  }, {
    key: "handleTextInputFocus",
    value: function handleTextInputFocus() {
      this.setState({
        editing: true,
        // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
        editedValue: this.getFormattedValue(this.state.value)
      });
    }
  }, {
    key: "handleTextInputChange",
    value: function handleTextInputChange(event) {
      this.setState({
        editedValue: event.target.value
      });
    }
  }, {
    key: "handleTextInputBlur",
    value: function handleTextInputBlur() {
      this.handleValueChange(true);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (this.props.updateOnEnter) {
        if (event.charCode === 13) {
          this.handleValueChange();
        }
      }
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange() {
      var manualEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = this.state.value;
      var editedValue = this.state.editedValue;

      if (this.props.preformatValue) {
        editedValue = this.props.preformatValue(editedValue);
      }

      var newValue = this.constrainValue(editedValue, manualEdit);

      if ((0, _isNaN2.default)(newValue)) {
        newValue = value;
      }

      this.props.onChange(newValue, value);
      this.setState({
        value: newValue,
        editing: false
      });
    }
  }, {
    key: "handleStep",
    value: function handleStep(direction, isIntermediate) {
      var value = this.state.value;
      var newValue = this.constrainValue(value + direction * this.props.stepSize); // Don't trigger intermediate calls to the user.

      if (!isIntermediate) {
        this.props.onChange(newValue, value);
      } // Update the state in case the props aren't going to be changing.


      this.setState({
        value: newValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), {}, {
        onHandleChange: this.handleStep,
        value: this.state.editing ? this.state.editedValue : this.getFormattedValue(this.state.value),
        isHandleDisabled: this.isHandleDisabled
      });

      if (this.props.editable) {
        props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
          hasNumericInput: true,
          onTextInputFocus: this.handleTextInputFocus,
          onTextInputChange: this.handleTextInputChange,
          onTextInputBlur: this.handleTextInputBlur,
          onKeyPress: this.handleKeyPress
        });
      }

      return /*#__PURE__*/_react.default.createElement(_baseStepper.default, props);
    }
  }]);
  return NumStepper;
}(_react.default.Component);

exports.default = NumStepper;
(0, _defineProperty2.default)(NumStepper, "displayName", 'NumStepper');
(0, _defineProperty2.default)(NumStepper, "propTypes", {
  editable: _propTypes.default.bool,
  formatter: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  onChange: _propTypes.default.func,
  preformatValue: _propTypes.default.func,
  snapValues: _propTypes.default.bool,
  stepSize: _propTypes.default.number,
  updateOnEnter: _propTypes.default.bool,
  value: _propTypes.default.number.isRequired
});
(0, _defineProperty2.default)(NumStepper, "defaultProps", {
  editable: false,
  formatter: null,
  max: -1,
  min: -1,
  onChange: function onChange() {},
  preformatValue: null,
  snapValues: false,
  stepSize: 1,
  updateOnEnter: false
});